<template>
  <div v-if="isInRole(['manual_subs'])">
    <toolbar />
    <zlick-navigation />
    <v-container fluid text-xs-center>
      <v-layout row wrap center>
        <v-flex xs12 offset-xs0>
          <v-stepper>
            <div class="v-stepper__content">
              <v-form ref="addsub" v-model="valid" lazy-validation>
                <v-text-field
                  v-model="subscriptionData.email"
                  validate-on-blur
                  :rules="[v => !!v || $t('email_required')]"
                  :label="$t('email')"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="subscriptionData.phone"
                  :label="$t('phone_number')"
                ></v-text-field>

                <v-text-field
                  v-model="subscriptionData.clientUserId"
                  :label="$t('clientUserId')"
                ></v-text-field>
               <v-menu
                v-model="datePickerShow"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="subscriptionData.subscriptionExpiresAt"
                    :label="$t('subscriptionExpiresAt')"
                    prepend-icon="event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="subscriptionData.subscriptionExpiresAt" @input="datePickerShow = false"></v-date-picker>
              </v-menu>
                <v-select
                  v-model="subscriptionData.selectedProduct"
                  validate-on-blur
                  :rules="[v => !!v || $t('product_required')]"
                  :label="$t('product')"
                  :items="products"
                  item-text="name"
                  :return-object="true"
                  required
                ></v-select>

                <v-select
                  v-model="subscriptionData.paymentType"
                  validate-on-blur
                  :rules="[v => !!v || $t('payment_type_required')]"
                  :label="$t('paymentType')"
                  :items="paymentTypes"
                  item-text="name"
                  :return-object="true"
                  required
                ></v-select>

                <v-btn :disabled="!valid" @click="addSubscriber">{{ $t('submit') }}</v-btn>
                <v-btn @click="clear">{{$t('cancel')}}</v-btn>
              </v-form>
            </div>
          </v-stepper>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :multi-line="snackbar.multiline"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn color="white" flat @click="snackbar.show = false">{{$t('close')}}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
/* eslint-disable */
import Toolbar from "./Toolbar";
import ZlickNavigation from "./ZlickNavigation";
import AuthenticationService from "../services/AuthenticationService";
import ProductsService from "../services/ProductsService";
import SubscriptionsService from '../services/SubscriptionsService'
import Raygun from "../services/Raygun";
import { mapState } from "vuex";
import moment from 'moment'

export default {
  components: {
    Toolbar,
    ZlickNavigation
  },
  data: () => ({
    valid: true,
    products: [],
    paymentTypes: [
      {
        name: 'External Payment',
        value: 'external_payment'
    }, {
        name: 'Unpaid',
        value: 'unpaid'
    }],
    subscriptionData: {
      datePickerShow: false,
      subscriptionExpiresAt: moment(moment().add(10, 'years').calendar()).format('YYYY-MM-DD'),
      clientUserId: "",
      phone: "",
      selectedProduct: undefined,
      paymentType: undefined,
      email: ""
    },
    snackbar: {
      timeout: 0,
      color: "success",
      mode: "vertical",
      show: false,
      multiline: true
    }
  }),
  created() {
    this.getProducts();
  },
  beforeCreate() {
    if (!AuthenticationService.isUserLoggedIn()) {
      this.$router.push("/login");
    }
  },
  computed: mapState({
    activeCognitoGroup: state => state.user.activeCognitoGroup
  }),

  watch: {
    activeCognitoGroup(newValue, oldValue) {
      console.log(`cognito Updating from ${oldValue} to ${newValue}`);
      this.getProducts();
    }
  },
  methods: {
    isInRole(roles) {
      return AuthenticationService.isInRole(roles);
    },
    formatDate (date, format = 'DD.MM.YYYY HH:mm:ss') {
      return moment(date).format(format)
    },
    async getProducts() {
      try {
        const response = await ProductsService.getProducts();
        this.products = response;
      } catch (error) {
        Raygun.send(error);
      }
    },
    clear() {
      this.subscriptionData = {
        subscriptionExpiresAt: moment(moment().add(10, 'years').calendar()).format('YYYY-MM-DD'),
        clientUserId: "",
        phone: "",
        selectedProduct: undefined,
        paymentType: undefined,
        email: ""
      };
    },
    async addSubscriber() {
      if (!this.$refs.addsub.validate()) return;
      let response
      try {
        response = await SubscriptionsService.createManualSubscription({
          productName: this.subscriptionData.selectedProduct.name,
          phone: this.subscriptionData.phone,
          email: this.subscriptionData.email.toLowerCase(),
          paymentType: this.subscriptionData.paymentType.value,
          clientUserId: this.subscriptionData.clientUserId,
          subscriptionExpiresAt: this.subscriptionData.subscriptionExpiresAt
        })
        
        this.snackbar.show = true;
        this.snackbar.color = "success";
        this.snackbar.text = this.$t("subscriber_added");
        this.clear();
      } catch (error) {
        Raygun.send(error)
        this.snackbar.show = true
        this.snackbar.color = 'error'
        this.snackbar.text = error.response.data.message
      }
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AddSubscriber.vue